import path from "path";
import { fileURLToPath } from "url";

import { PrismaClient } from "@prisma/client";

// Get directory path
const __filename = fileURLToPath(import.meta.url);
const __dirname = path.dirname(__filename);

// Detect if we're in development or production
const isDev = __dirname.includes("/src") || __dirname.includes("\\src");
console.log("🚀 ~ file: prisma.ts:17 ~ isDev:", isDev); // for debug

// Set the database path based on environment
const dbPath = isDev
  ? path.resolve(__dirname, "../../prisma/geo.db")
  : path.resolve(__dirname, "../prisma/geo.db");

// Type declaration for global prisma
declare global {
  // eslint-disable-next-line no-var
  var prisma: any;
}

// Initialize or reuse the Prisma client
const db =
  global.prisma ||
  new PrismaClient({
    datasources: {
      db: {
        url: `file:${dbPath}`,
      },
    },
  });

// Cache the client in development
if (process.env.NODE_ENV !== "production") {
  global.prisma = db;
}

export default db;
